// CRM 2.0 · M12 Template Builder: shared bits for the Templates screens.
import cls from "./Templates.module.css";

export const STATUS = {
  DRAFT: { label: "Draft", chip: cls.cLt },
  IN_APPROVAL: { label: "In approval", chip: cls.cWarn },
  RETURNED: { label: "Returned with comments", chip: cls.cErr },
  APPROVED: { label: "Approved", chip: cls.cOk },
  LIVE: { label: "Live", chip: cls.cOk },
  RETIRED: { label: "Retired", chip: cls.cGrey },
};

export const EDITABLE = ["DRAFT", "RETURNED"];

export const STEPS = ["Upload", "Map fields & edit", "QR", "Check & preview", "Send for approval"];

export const BLANK_KINDS = {
  MARKER: "Field marker {…}",
  MERGE_FIELD: "Word merge field",
  HIGHLIGHT: "Highlighted",
  UNDERSCORES: "Line ____",
  DOTS: "Dots ......",
  GUILLEMETS: "«…»",
  BRACKETS: "[ ]",
  EMPTY_ROW: "Empty table row",
  INSERTED: "Added",
};

export const SUGGESTION_SOURCE = {
  MARKER: "Field marker",
  MARKER_NEAR: "Field marker (closest field)",
  MERGE_FIELD: "Learned merge field",
  WORDS: "Nearby words",
  COLUMN_HEADING: "Column heading",
  TYPED: "Typed value",
  PEN: "Filled by hand",
  NONE: "",
};

// Same rule as the backend (middlewares/salesAppUserAuth.js): level 1 sees everything,
// otherwise every step of the path must be switched on.
export function canDo(user, ...path) {
  const role = user?.roleId;
  if (Number(role?.level) === 1) return true;
  let node = role?.accessibleTabs?.Templates;
  if (!node?.isAccessible) return false;
  for (const key of path) {
    node = node?.[key];
    if (!node?.isAccessible) return false;
  }
  return true;
}

export function fmtDate(ms) {
  if (!ms) return "";
  return new Date(Number(ms)).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function kindName(settings, key) {
  const kind = (settings?.documentKinds || []).find((k) => k.key === key);
  return kind ? kind.name : key;
}

// DC-204 "Which applicant?" for an applicant / POA field outside the buyer block (DocTemplateBlanks.applicantPick)
export const APPLICANT_PICKS = [
  ["APPLICANT_1", "1st applicant", "1st"],
  ["APPLICANT_2", "2nd applicant", "2nd"],
  ["APPLICANT_3", "3rd applicant", "3rd"],
  ["APPLICANT_4", "4th applicant", "4th"],
  ["ALL_TOGETHER", "All applicants together (“A, B and C”)", "All"],
];
export const pickTag = (pick) => (APPLICANT_PICKS.find(([k]) => k === pick) || [])[2] || "";
export const pickName = (pick) => (pick === "EACH" ? "Each applicant (buyer block)" : (APPLICANT_PICKS.find(([k]) => k === pick) || [])[1] || "");

export const isApplicantField = (field) => !!field && field.repeatKind === "EACH_APPLICANT";

// same rule as the backend (blocks.js): Repeat -> buyer and signature blocks; Keep as typed -> all four blocks
export function inApplicantBlock(blocks, blockKey) {
  if (!blockKey) return false;
  return (blocks?.buyerMode || "REPEAT") === "REPEAT" ? ["BUYER", "SIGNATURE"].includes(blockKey) : true;
}

// Templates › Settings › Buyer & signatures (TEMPLATE_BUILDER.partyDefaults): how a new draft starts; Legal can
// change any of it in the draft. Not set = these (same as the backend, blocks.js partyDefaults).
export const PARTY_DEFAULTS = {
  buyerFields: ["buyer.salutation", "buyer.fullName", "buyer.age", "buyer.occupation", "buyer.pan"],
  buyerLineUpCm: 9,
  signFields: ["buyer.salutation", "buyer.fullName"],
  signNumber: "DOT",
  signLeadOnce: true,
};
export function partyDefaults(settings) {
  const s = (settings && settings.partyDefaults) || {};
  const list = (v, d) => (Array.isArray(v) && v.length ? v.map(String) : d);
  const cm = Number(s.buyerLineUpCm);
  return {
    buyerFields: list(s.buyerFields, PARTY_DEFAULTS.buyerFields),
    buyerLineUpCm: Number.isFinite(cm) && cm >= 0 && s.buyerLineUpCm !== undefined && s.buyerLineUpCm !== null && s.buyerLineUpCm !== "" ? cm : PARTY_DEFAULTS.buyerLineUpCm,
    signFields: list(s.signFields, PARTY_DEFAULTS.signFields),
    signNumber: ["DOT", "BRACKET", "NONE"].includes(s.signNumber) ? s.signNumber : PARTY_DEFAULTS.signNumber,
    signLeadOnce: s.signLeadOnce !== undefined ? !!s.signLeadOnce : PARTY_DEFAULTS.signLeadOnce,
  };
}
